
namespace Matrix.Rebalancer {

    @Serenity.Decorators.registerClass()
    export class AccountOverrideGrid extends SiteEntityGrid<AccountOverrideRow, any> {
        protected getColumnsKey() { return 'Rebalancer.AccountOverride'; }
        protected getDialogType() { return AccountOverrideDialog; }
        protected getIdProperty() { return AccountOverrideRow.idProperty; }
        protected getLocalTextPrefix() { return AccountOverrideRow.localTextPrefix; }
        protected getService() { return AccountOverrideService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}